import Service from "../../../Services/index";

const damages = {
    namespaced: true,
    state: {
        damages_cost: [],
        form: {
            transport_type_id: "",
            driver: null,
            damage_total: "",
            license_plate: "",
        },
        dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        }
    },
    mutations: {
        SET_DAMAGES_COST: (state, res) => {
            state.damages_cost = res.data;
            state.dataPaginate = {
                current_page: res.current_page,
                from: res.from,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to
            }
        },
    },
    actions: {
        setDamages({commit}, page) {
            return Service.Damages.getDamages(page)
                .then(data => {
                    //console.log(data)
                    commit("SET_DAMAGES_COST", data);
                });
        },
        showDamages({commit}, data) {
            return Service.Damages.showDamages(data.driver_id, data.page).then(res => {
                commit("SET_DAMAGES_COST", res)
            })
        },
        saveAmountDamages({commit}, data) {
            return Service.Damages.createDamages(data);
        },
        deleteDamages({commit}, data) {
            return Service.Damages.deleteDamages(data);
        },
        searchDamages({commit}, {page = 1, search}) {
            return Service.Damages.searchDamages(page, search)
                .then(data => {
                    //console.log(data)
                    commit("SET_DAMAGES_COST", data)
                })
        },
    }
};
export default damages;
